import PropTypes from "prop-types";
import React from "react";
import SearchBarApp from "./SearchBar/SearchBarApp";
import SearchResultList from "./SearchResultList";
import { SearchBarProvider, SearchProvider } from "@providers";

type SearchEngineProps = {
  mode: "list" | "grid";
  showSearchBar?: boolean;
};

const SearchEngine: React.FC<SearchEngineProps> = ({
  mode,
  showSearchBar = true,
}) => {
  return (
    <SearchProvider>
      {showSearchBar && (
        <SearchBarProvider>
          <SearchBarApp />
        </SearchBarProvider>
      )}
      {<SearchResultList />}
    </SearchProvider>
  );
};

SearchEngine.propTypes = {
  //
};

export default SearchEngine;
